import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Spacing, Text, Badge } from '@reservamos/elements';

/**
 * ReserveCode component.
 *
 * Displays a reserve code with a badge styling.
 *
 * @param {string} reserveCode - The reserve code to display.
 * @returns {JSX.Element|null} The rendered ReserveCode component or null if no reserve code.
 */
const ReserveCode = ({ reserveCode }) => {
  const { t } = useTranslation('purchase');

  if (!reserveCode) {
    return null;
  }

  return (
    <Spacing size="XS" alignItems="center" marginLeft="S">
      <Text size="S" color="grayLight" weight="semibold" whiteSpace="nowrap">
        {t('label.reserve_code')}
      </Text>
      <Badge roundCorners type="gray">
        <Text size="S" color="grayLight" weight="semibold" elementType="span" letterSpacing="1">
          {reserveCode}
        </Text>
      </Badge>
    </Spacing>
  );
};

ReserveCode.propTypes = {
  reserveCode: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
};

ReserveCode.defaultProps = {
  reserveCode: null,
};

export default ReserveCode;
